/** Sidebar nav item data. Used by DesktopSidebar and tests. No React/icons deps. */
export interface SidebarNavItemData {
  name: string;
  href: string;
  flipIcon?: boolean;
}

/** Base sidebar navigation items. Add new items here; the sidebar and tests update automatically. */
export const SIDEBAR_NAV_ITEMS: SidebarNavItemData[] = [
  { name: "Home", href: "/" },
  { name: "Reports", href: "/reports" },
  { name: "Sessions", href: "/sessions" },
  { name: "Players", href: "/players" },
  { name: "Analyze", href: "/analyze" },
  { name: "Develop", href: "/develop" },
  { name: "Reboot Live", href: "/reboot-live", flipIcon: true },
];
